import React from "react";

const AppContext = React.createContext({
    user: undefined,
    profile: undefined,
    isAuthenticated: false,
    isEnabled: false,
    shopifyDetail: {
        products: [],
        productIds: [],
        total: 0
    },
    initiateLogout: undefined,
    addShopifyProduct: undefined,
    removeShopifyProduct: undefined,
    clearSelectedShopifyProducts: undefined,
    addAllShopifyProducts: undefined,
});

export default AppContext;
